import { Map, List } from 'immutable';

import {
  COGNITO_FORM_ANSWER_LIST_REQUEST,
  COGNITO_FORM_ANSWER_LIST_SUCCESS,
  COGNITO_FORM_ANSWER_LIST_FAILURE,
  COGNITO_FORM_ANSWER_READ_REQUEST,
  COGNITO_FORM_ANSWER_READ_SUCCESS,
  COGNITO_FORM_ANSWER_READ_FAILURE,
  COGNITO_FORM_ANSWER_CSV_DOWNLOAD_REQUEST,
  COGNITO_FORM_ANSWER_CSV_DOWNLOAD_SUCCESS,
  COGNITO_FORM_ANSWER_CSV_DOWNLOAD_FAILURE,
  COGNITO_FORM_ANSWER_DELETE_REQUEST,
  COGNITO_FORM_ANSWER_DELETE_SUCCESS,
  COGNITO_FORM_ANSWER_DELETE_FAILURE,
} from './actions';
import Logger from '../../../lib/Logger';

export default function cognitoFormAnswers(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    'debug',
    `[cognitoFormAnswers.reducers] cognitoFormAnswers(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case COGNITO_FORM_ANSWER_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case COGNITO_FORM_ANSWER_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ['pages', action.order, action.limit, action.page],
          List(action.result)
        );

    case COGNITO_FORM_ANSWER_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case COGNITO_FORM_ANSWER_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case COGNITO_FORM_ANSWER_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case COGNITO_FORM_ANSWER_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case COGNITO_FORM_ANSWER_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case COGNITO_FORM_ANSWER_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case COGNITO_FORM_ANSWER_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case COGNITO_FORM_ANSWER_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true,
      });

    case COGNITO_FORM_ANSWER_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case COGNITO_FORM_ANSWER_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `cognitoFormAnswers.reducers loaded.`);
